import React from "react";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { usePageHeader } from "../../context/LayoutContext";
import CameraEnhanceIcon from "@mui/icons-material/CameraEnhance";
import { useOrgId } from "../../shared/auth/orgContext";
import BodycamOnboardingPanel from "../../shared/components/BodycamOnboardingPanel";
import { LoadingSkeleton } from "./components";

const ConnectBodycam: React.FC = () => {
  const navigate = useNavigate();
  const organizationId = useOrgId();

  usePageHeader({
    title: "Connect Bodycam",
    subtitle:
      "Select your vendor and enter credentials to securely sync evidence",
    icon: <CameraEnhanceIcon />,
  });

  // The layout doesn't gate child routes on the org being resolved, so this
  // page can mount before AuthTokenBridge has decoded org_id (or if the claim
  // is absent). The panel's queries are station-scoped, so hold the skeleton
  // until we have a real stationId rather than asserting non-null.
  if (!organizationId) {
    return <LoadingSkeleton />;
  }

  return (
    <Container
      maxWidth={false}
      sx={{
        minHeight: "80vh",
        py: 4,
        maxWidth: { xs: 600, xxl: 750, uhd: 900 },
      }}
    >
      <BodycamOnboardingPanel
        stationId={organizationId}
        onReturnHome={() => navigate("/")}
      />
    </Container>
  );
};

export default ConnectBodycam;
export { ConnectBodycam };
